<p-floatLabel>
  <p-multiselect #informationSourceMultiSelect
    id="informationSourceMultiSelect"
    name="informationSourceMultiSelect"
    [options]="informationSources"
    [(ngModel)]="selectedInformationSources"
    [showClear]="true"
    [filter]="true"
    styleClass="w-100"
    appendTo="body"
    [selectedItemsLabel]="l('::SelectedItems', selectedInformationSources?.length)"
    (ngModelChange)="onSelected()"
    optionLabel="name">
    <ng-template let-option pTemplate="item">
      {{ option?.name }}
    </ng-template>
  </p-multiselect >
  <label for="informationSourceMultiSelect">
    <app-label-content [isRequired]="isRequired">
      {{ l('::InformationSources') }}
    </app-label-content>
  </label>
</p-floatLabel>
